import $ from 'jquery';
import { AI_FEATURE_CATEGORIES } from './aiFeatureCategories';

export const AI_SEARCH_SUGGESTIONS = [
  'occhiali',
  'graffi',
  'sfondo',
  'sorriso',
  'abbraccio',
];

export function normalizeText(str = '') {
  if (str === null || str === undefined) {
    return '';
  }
  return String(str)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function buildSearchIndex(categories = AI_FEATURE_CATEGORIES) {
  const index = [];
  categories.forEach((category) => {
    category.features.forEach((feature) => {
      const haystack = normalizeText(
        [
          feature.title,
          feature.caption,
          category.title,
          (feature.keywords || []).join(' '),
          feature.description,
          feature.whenToUse,
        ]
          .filter(Boolean)
          .join(' ')
      );
      index.push({
        featureId: feature.id,
        categoryId: category.id,
        haystack,
      });
    });
  });
  return index;
}

export function matchFeatures(index, query) {
  const terms = normalizeText(query).split(' ').filter(Boolean);
  if (!terms.length) {
    return new Set(index.map((entry) => entry.featureId));
  }
  return new Set(
    index
      .filter((entry) => terms.every((term) => entry.haystack.includes(term)))
      .map((entry) => entry.featureId)
  );
}

export function generateSearchBoxHTML() {
  const chipsHTML = AI_SEARCH_SUGGESTIONS.map(
    (suggestion) => `
      <button
        type="button"
        class="ai-search-suggestion-chip"
        data-suggestion="${suggestion}"
      >${suggestion}</button>
    `
  ).join('');

  return `
    <div class="ai-search-box sidebar-box">
      <div class="ai-search-input-wrapper">
        <svg class="ai-search-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
        </svg>
        <input
          type="text"
          id="ai-feature-search-input"
          class="form-control form-control-sm"
          placeholder="Cosa vuoi sistemare? es. foto rovinata"
          autocomplete="off"
          aria-label="Cerca uno strumento"
        />
        <button
          type="button"
          id="ai-search-clear"
          class="ai-search-clear d-none"
          aria-label="Azzera ricerca"
        >&times;</button>
      </div>
      <div
        id="ai-search-empty-state"
        class="ai-search-empty-state d-none"
        role="status"
        aria-live="polite"
      >
        <div>Nessuno strumento trovato. Prova con:</div>
        <div class="ai-search-suggestions">${chipsHTML}</div>
        <button type="button" class="btn btn-sm btn-link p-0 mt-2" id="ai-search-open-tour">
          Sfoglia tutti gli strumenti
        </button>
      </div>
    </div>
  `;
}

function defaultTrackSearch({ query, resultsCount }) {
  import('~src/tracking')
    .then(({ trackEventDebounced }) => {
      trackEventDebounced('AI Sidebar Search', { query, resultsCount });
    })
    .catch(() => {});
}

export function initAiFeatureSearch({
  categories = AI_FEATURE_CATEGORIES,
  trackSearch = defaultTrackSearch,
} = {}) {
  const index = buildSearchIndex(categories);

  const applyFilter = (rawQuery) => {
    const query = normalizeText(rawQuery);
    const isActive = query.length > 0;
    const matches = matchFeatures(index, rawQuery);

    $('[data-search-feature-id]').each(function () {
      const featureId = $(this).attr('data-search-feature-id');
      $(this).toggleClass('d-none', isActive && !matches.has(featureId));
    });

    $('[data-search-category-id]').each(function () {
      const hasVisibleFeatures =
        $(this).find('[data-search-feature-id]').not('.d-none').length > 0;
      $(this).toggleClass('d-none', isActive && !hasVisibleFeatures);
    });

    $('.ai-feature-count').toggleClass('d-none', isActive);
    $('#ai-search-clear').toggleClass('d-none', !isActive);
    $('#ai-search-empty-state').toggleClass(
      'd-none',
      !isActive || matches.size > 0
    );

    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update();
    }

    if (isActive) {
      trackSearch({ query, resultsCount: matches.size });
    }
  };

  $('body')
    .off('input.aiFeatureSearch')
    .on('input.aiFeatureSearch', '#ai-feature-search-input', function () {
      applyFilter($(this).val());
    });

  $('body')
    .off('click.aiFeatureSearchClear')
    .on('click.aiFeatureSearchClear', '#ai-search-clear', function () {
      $('#ai-feature-search-input').val('');
      applyFilter('');
    });

  $('body')
    .off('click.aiFeatureSearchChip')
    .on('click.aiFeatureSearchChip', '.ai-search-suggestion-chip', function () {
      const suggestion = $(this).attr('data-suggestion');
      $('#ai-feature-search-input').val(suggestion);
      applyFilter(suggestion);
    });

  $('body')
    .off('click.aiFeatureSearchTour')
    .on('click.aiFeatureSearchTour', '#ai-search-open-tour', function (e) {
      e.preventDefault();
      $('#ai-feature-search-input').val('');
      applyFilter('');
      $('#ai-guided-tour-btn').trigger('click');
    });
}
